import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EntityType, FieldOption, FieldType, UserDocument } from 'server-model';
import { CRMFieldDataService, IAMService } from 'src/app/services/services.module';

@Component({
  selector: 'app-global-input',
  templateUrl: './global-input.component.html',
  styleUrl: './global-input.component.scss'
})
export class GlobalInputComponent {
  @Input() is_single_input_field: boolean = false;
  @Input() field_type: FieldType | null = null;
  @Input() name: string = '';
  @Input() label: string = '';
  @Input() value: any='';
  @Input() description: string = '';
  @Input() has_unique_value: boolean = false;
  @Input() is_readonly_value: boolean = false;
  @Input() required: boolean = false;
  @Input() hideOptional: boolean = false;
  @Input() hideEmptyOption: boolean = false;
  @Input() isInvalid: boolean = false;
  @Input() showLabel: boolean = true;
  @Input() errorText: string = '';
  @Input() options: FieldOption[] = [];
  @Input() allUsers: UserDocument[] = [];
  @Output() inputValueChange = new EventEmitter<any>();
  @Output() invalidateField = new EventEmitter<boolean>();
  fieldTypes = FieldType;

  constructor(
    private iamService: IAMService,
    private crmFieldDataService: CRMFieldDataService,
  ) { }

  inputValueChangeEvent(value: any) {
    if (this.has_unique_value && this.is_single_input_field) {
      this.checkUniqueValue(value);
    }
    this.inputValueChange.emit(value);
  }

  invalidateFieldEvent(isInvalid: boolean) {
    this.invalidateField.emit(isInvalid);
  }

  async checkUniqueValue(value: any) {
    try {
      const organisationId = this.iamService.getOrganisationId();
      let isUnique = [];
      if (this.name === 'email' || this.name === 'phone') {
        if (value.length && value[0].value) {
          isUnique = (await this.crmFieldDataService.validateField(organisationId, EntityType.CONTACT, [{ name: this.name, value: value[0].value }])).data;
        }
      } else {
        if (value) {
          isUnique = (await this.crmFieldDataService.validateField(organisationId, EntityType.CONTACT, [{ name: this.name, value: value }])).data;
        }
      }
      if (isUnique.length) {
        this.isInvalid = true;
        this.errorText = `Value should be unique. Contact with same ${this.label} already exists`;
        this.invalidateField.emit(this.isInvalid);
      }
    } catch (error) {
      console.log(error)
    }
  }
}
